import React from 'react';
import './SplashScreen.css';

const SplashScreen = () => {
  return (
    <div className="splash-wrapper">
      <div className="splash-main-container">
        {/* Central Logo */}
        <div className="trade-house-logo">
          <span className="logo-text">TH</span>
        </div>
        
        {/* Brand Identity */}
        <div className="text-section">
          <h1 className="brand-name">Trade House</h1>
          <p className="brand-motto">Live the Market, Trade the Future</p>
        </div>

        {/* Dynamic Candle Loader (Only in Center) */}
        <div className="trading-candles-loader">
          <div className="mini-candle green m1"></div>
          <div className="mini-candle red m2"></div>
          <div className="mini-candle green m3"></div>
          <div className="mini-candle red m4"></div>
        </div>
      </div>

      <div className="splash-footer-fixed">
        <span>EST. 2026 • GLOBAL TRADING NODE</span>
      </div>
    </div>
  );
};

export default SplashScreen;